// Copyright (c) StrangeBee 2023

import { HTMLColors } from '@Constants/colors';
import { formatFileSize } from '@Helpers/stats';
import React, { ReactElement } from 'react';
import { MonitorDiskOutput } from 'thehive-sdk';

import './PlatformMonitorStatus.scss';
import { Tooltip } from 'antd';

interface PlatformMonitorStatusProps {
    data: MonitorDiskOutput;
}

export const PlatformMonitorStatus = ({ data }: PlatformMonitorStatusProps): ReactElement => {
    const size = ((data.totalSpace - data.freeSpace) * 100) / data.totalSpace;

    return (
        <div className="platform-monitor-status">
            <span className="platform-monitor-status__title">
                <Tooltip title={data.location}>
                    <span className="platform-monitor-status__title-path">{data.location} </span>
                </Tooltip>
                <span className="platform-monitor-status__title-space">{`${formatFileSize(
                    data?.totalSpace - data?.freeSpace,
                )} / ${formatFileSize(data?.totalSpace)}`}</span>
            </span>
            <div className="platform-monitor-status__container">
                <div
                    className="platform-monitor-status__fill"
                    style={{ width: size + '%', backgroundColor: size >= 80 ? HTMLColors.RED : HTMLColors.GREEN }}
                />
            </div>
        </div>
    );
};
